import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import {askCalendarUrl} from "./calendar_modal.ts";
import * as progressbar from "../util/progressbar.ts";
import * as FwDatas from "../FwDatas.ts";
import { checkEventLimitOntry } from "./calendarclean.ts";

import Icons from "../svg/Icons.ts";

import TPL_ICAL from "../modal/part/cal_edit_icalui.mustache";
import { pickFileFromDevice } from "../lib/FileUtils.ts";


Html.registerDom({
  calicalgenerate(){
    const node = this.closest<HTMLElement>('.content');
    const metaId = Html.getDomMetaId(this);
    if(!node) return;
    ApiServer.evticalvisibleurl(true,metaId,function(url){
      Html.setHtml(node,TPL_ICAL,{icalurl:url})
    })

  },
  async calicalrefresh(){
    const node = this.closest<HTMLElement>('.content');
    const metaId = Html.getDomMetaId(this);
    const doit = await modal.confirm({title:"calendars.icalrefreshconfirmtitle",message:"calendars.icalrefreshconfirmmessage"})

    if(doit && node){
      ApiServer.evticalvisibleurl(true,metaId,function(url){
        Html.setHtml(node,TPL_ICAL,{icalurl:url})
      })
    }
  },
  async calicaldelete(){
    const node = this.closest('.content');
    const metaId = Html.getDomMetaId(this);

    if(!await modal.confirmDelete({title:"calendars.icaldeleteconfirmtitle",message:"calendars.icaldeleteconfirmmessage"})) return;

    await ApiServer.evticalvisibleurldelete(metaId)
    if(node) Html.setHtml(node,TPL_ICAL,{})


  },
  async icalimporttype(){
    var TPL = await import("../calendar/modal_importtype.mustache")
    modal.openDomModal(TPL,{})
  },
  async icalimportbyurl(){
    var url = await askCalendarUrl({
      title:'calendars.importbyurl.title',
      image:"/images/calendar_dialog_import_url.svg",
      message:"calendars.importbyurl.label",
      sub:"calendars.importbyurl.sub",
      placeholder:"calendars.importbyurl.placeholder",
      buttonName:"actions.import"
    })
    if(url){
      try{
        var resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file:url});
        if(resp.rightFlag ==='KO_PREMIUM'){
          var doit30 = await modal.askAsPromise({
            title:"errors.oops",
            message:"calendars.importicslimit",
            lottie:"images/lottie/dizzy_face.json",
            button:[
              {title:"actions.gopremium",class:"premium",value:'false',action:"takepremium"},
              {title:"actions.later",class:"secondary",value:'true'}
            ]
          })
          if(doit30==='true'){
            resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file:url,indexes:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]});
          }else{
            modal.closeDomModal();
            return;
          }
        }
        modal.closeDomModal();
        var key = (resp.updated)?(resp.created?'calendars.importicsresult2':'calendars.importicsresult3'):'calendars.importicsresult1'
        modal.toast({
          svg:Icons.ic_done,
          text:i18n.get(key,resp)
        });
        amplify.publish('eventUpdated')
      }catch(err){
        if(err.code==='408'){
          modal.oops('eventclean.import_limit_exceeded')
        }else{
          modal.oops('calendars.calbyurl.errortext');
        }
      }
    }
  },
  async icalimportbyfile(){
    const
      files = await pickFileFromDevice("text/calendar");
    if(files.length===0){
      return;
    }
    const
      file = files[0],
      eventsCount = await countEventInIcalFile(file),
      canAdd = await checkEventLimitOntry(undefined,eventsCount);

    if(!canAdd){
      modal.oops('eventclean.import_limit_exceeded')
      return;
    }
    var indexes = [];
    if(FwDatas.getPermission("icsconnect")==='takepremium' && eventsCount>30){
      var result = await modal.askAsPromise({
        title:"errors.oops",
        message:"calendars.importicslimit",
        lottie:"images/lottie/dizzy_face.json",
        button:[
          {title:"actions.gopremium",class:"premium",value:"false",action:"takepremium"},
          {title:"actions.later",class:"secondary",value:"true"}
        ]
      })
      if(result==="true"){
        indexes=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
      }else{
        return;
      }
    }

    try{
      var resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file,indexes});
      var key = (resp.updated)?(resp.created?'calendars.importicsresult2':'calendars.importicsresult3'):'calendars.importicsresult1'
      modal.toast({
        svg:Icons.ic_done,
        text:i18n.get(key,resp)
      });
      amplify.publish('eventUpdated')
    }catch(err){
      console.log(err)
      modal.oops('calendars.calbyurl.errortext');
    }
  }
})

async function countEventInIcalFile(file :File) :Promise<number>{
  return new Promise((resolve,reject)=>{
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      var fileAsString = event.target.result as string;
      resolve((fileAsString.match(/BEGIN:VEVENT/g) || []).length);
    });
    reader.addEventListener('error', (error) => {
      reject(error);
    });
    reader.readAsText(file);
  })

}